module.exports = __webpack_public_path__ + "img/hot-tub.63819127.svg";